{
  "chain_config": "chainConfig.json",
  "table_encoding": {
    "Json": {
      "filepath": "stateConfig.json"
    }
  }
}
